import { getApiErrorMessage } from "@/lib/apiErrors";

const FALLBACK = "Échec de la mise à jour de la commande.";

/**
 * Map an RTK Query error from updateOrder (PATCH /api/orders/{uuid}) into a
 * French message. The edit keys (see the order editing API contract, §1.3)
 * and the scope keys of SFAPI-178 live in the shared map
 * (`src/lib/apiErrorMessages.ts`); anything else gets the fallback.
 */
export function translateOrderUpdateError(error: unknown): string {
  return getApiErrorMessage(error, FALLBACK);
}
